/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Scaffold from '../../core/Scaffold/Scaffold';
import ExamsList from './ExamsList';

class Exams extends Component {
  render() {
    return (
      <Scaffold title="Exames">
        <ExamsList />
      </Scaffold>
    );
  }
}

export default withRouter(Exams);
